import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { collection, collectionData, Firestore, query, where } from '@angular/fire/firestore';
import { WindowRefService } from '../modules/share/services/window-ref.service';

export interface Agent {
  _type: 'agent';
  id: string;
  title: string;
  pathName: string;
  status: '0' | '1';
  firstNames: string[];
  lastNames: string[];
  phones: string[];
  photos: {
    fid: string;
    original: string;
    alt: string;
    title: string;
    derivatives: {
      searchResult: string;
    };
  }[];
  services: {
    tid: string;
  }[];
  types: {
    tid: string;
  }[];
  offices: {
    nid: string;
  }[];
  travelLinks: {
    label: string;
    url: string;
  }[];
  insuranceLinks: {
    label: string;
    url: string;
  }[];
  appointmentLinks: {
    label: string;
    url: string;
  }[];
}

@Injectable({ providedIn: 'root' })
export class AgentService {
  private firestore = inject(Firestore);
  private windowRef = inject(WindowRefService);
  agents$: Observable<Agent[]>;

  constructor() {
    // this.agentsRef = this.afs
    //   .collection('wss-aaa-web')
    //   .doc(this.windowRef.nativeWindow.metaData.clubId)
    //   .collection('data')
    //   .doc('drupal')
    //   .collection('nodes', (ref) => {
    //     let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
    //     query = query.where('_type', '==', 'agent');
    //     return query;
    //   });
    // this.agents$ = this.agentsRef.snapshotChanges().pipe(
    //   map((agents: DocumentChangeAction<Agent>[]) => {
    //     return agents.map((result) => {
    //       if (result) {
    //         const data = result.payload.doc.data();
    //         data.id = result.payload.doc.id;
    //         return data;
    //       }
    //       return result;
    //     });
    //   }),
    // );
    // Todo: need to test
    const clubId = this.windowRef.clubId;
    const agentsCollection = collection(this.firestore, `wss-aaa-web/${clubId}/data/drupal/nodes`);
    const agentsQuery = query(agentsCollection, where('_type', '==', 'agent'));
    this.agents$ = collectionData(agentsQuery, { idField: 'id' }) as Observable<Agent[]>;
  }
}
